import { saveAs } from 'file-saver';
import { t } from 'i18next';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Trans } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
import { ReactComponent as Arrow } from '../../../assets/svg/ArrowDownPerm.svg';
import { ReactComponent as FileDoc } from '../../../assets/svg/file-doc.svg';
import { ReactComponent as Plus } from '../../../assets/svg/Plus.svg';
import { useAuth } from '../../../hooks';
import { useGetXlsMutation } from '../../../services/api';
import {
    AccessPermission,
    AccessPermissionStatus,
    Contract,
    RegistryRecord,
    RegistryRecordType,
    SourcesType,
    useDeleteContractMutation,
    useGetMediaHeaderMutation,
    useLazyGetRegistryQuery,
    useSetAccessPermissionCommentMutation,
    useSetContractCommentMutation,
    useUpdateAccessPermissionStatusMutation
} from '../../../services/content_v1';
import { BASE_URL } from '../../../services/reauth';
import { AccountResType, useGetAccountListQuery } from '../../../services/users_v1';
import { OuterMenuProps } from '../../../types/index';
import { extractErrorDetail, toMplatValidity, useIsAdmin, useIsConsumer, useIsPartnerSource, useIsProvider } from '../../common';
import Button from '../Button/Button';
import { CheckBox } from '../CheckBox';
import Table from '../DataTable/Table';
import TableBody from '../DataTable/TableBody';
import { TableColumn } from '../DataTable/TableColumn';
import TableHeader from '../DataTable/TableHeader';
import { TableHeaderColumn } from '../DataTable/TableHeaderColumn';
import TableRow from '../DataTable/TableRow';
import { DatePicker } from '../DatePicker';
import ImageLoader from '../ImageLoader';
import { Modal } from '../Modal';
import { CommentModalDialog } from '../Modals/CommentModal';
import ContractModal from '../Modals/ContractModal';
import { CreateContractModal } from '../Modals/CreateContractModal';
import { PermissionViewModal } from '../Modals/PermissionViewModal';
import MultiSelect from '../MultiSelect';
import { Searcher } from '../Searcher';
import { getContractStatus, toPermissionStatus } from './DealPortfolioProviderMatrix';

export const AVAIL_SOURCES = [
    { value: SourcesType.ANY, label: t('tv:ANY_SOURCE') },
    { value: SourcesType.SATELLITE, label: t('tv:SATELLITE') },
    { value: SourcesType.LAND, label: t('tv:LAND') },
    { value: SourcesType.MEDIALOGISTIKA, label: t('tv:MEDIALOGISTIC') },
    { value: SourcesType.OTHER, label: t('tv:OTHER_SOURCE') },
];

interface CreateDocumentModalProps {
    isOpen: boolean,
    onClose: () => void,
    onCreateDocument: () => void,
}

export function CreateDocumentModal({ isOpen, onClose, onCreateDocument }: CreateDocumentModalProps) {
    return (
        <Modal className={'popup_message'} isOpen={isOpen} onClose={() => onClose()}>
            <div className="registry-new">
                <h3 className="registry-new__heading">
                    <Trans>New contract</Trans>
                </h3>
                <div className="registry-new__list">
                    <Button className="_green" type="button" onClick={() => { onCreateDocument(); onClose(); }}>
                        <span className="btn__icon">
                            <Plus /><Trans>Contract</Trans>
                        </span>
                    </Button>
                    <Link to={'/access/permissions/create'} className="btn" type="button">
                        <span className="btn__icon">
                            <Plus /><Trans>Permission</Trans>
                        </span>
                    </Link>
                </div>
            </div>
        </Modal>
    );
}

// interface PermissionModalProps {
//     isOpen: boolean,
//     onClose: () => void,
// }

// export function PermissionModalModal({ isOpen, onClose }: PermissionModalProps) {
//     const [createPermission] = useCreateAccessPermissionMutation();
//     const [refetch, { data: listData }] = useLazyGetTVListQuery();
//     const [refetchUsers, { data: users }] = useLazyGetAccountListQuery();
//     const auth = useAuth();

//     const [success, setSuccess] = useState<boolean>();
//     const [fail, setFail] = useState<string>();
//     const successClass = 'popup_message';

//     const [haveLic, setHaveLic] = useState<boolean>(true);
//     const [licNum, setLicNum] = useState('');
//     const [licDate, setLicDate] = useState('');
//     const [permPeriod, setPermPeriod] = useState(1);
//     const [startDate, setStartDate] = useState<Date | undefined>();
//     const [stopDate, setStopDate] = useState<Date | undefined>();
//     const [units, setUnits] = useState<number[]>([]);
//     const [qualities, setQualities] = useState<number[]>([]);
//     const [source, setSource] = useState<number>(1);
//     const [psdetails, setPSDetails] = useState('');
//     const [recipient, setRecipient] = useState<number>(NaN);

//     const availUsers = useMemo(() => {
//         if (users?.results.data) {
//             return users.results.data.map((u) => ({ value: u.id, label: `${u.name} [${u.id}]` }));
//         }
//         return [];
//     }, [users]);

//     const availUnits = useMemo(() => {
//         if (listData?.results.data) {
//             return listData.results.data.map((tv) => ({ value: tv.id, label: tv.title }));
//         }
//         return [];
//     }, [listData]);

//     const availQualities = useMemo(() => {
//         if (listData?.results) {
//             const tmp = listData.results.data.reduce((acc, unit) => {
//                 unit.tvqualities.forEach((q) => {
//                     acc[q.id] = { value: q.id, label: q.name };
//                 });
//                 return acc;
//             }, {} as Record<string, { value: number, label: string }>);
//             return Object.values(tmp);
//         }
//         return [];
//     }, [listData]);

//     // const availQualities = useMemo(() => {
//     //     if (refBook?.results) {
//     //         return refBook.results.quality.map((ref) => ({ value: ref.id, label: `${ref.displayname}` }));
//     //     }
//     //     return [];
//     // }, [refBook]);

//     useEffect(() => {
//         refetch({ offset: 0, limit: -1 });
//         refetchUsers({});
//         if (isOpen) {
//             setSuccess(false);
//             setFail('');
//         }
//     }, [isOpen]);

//     useEffect(() => {
//         if (permPeriod === 2) {
//             setStartDate(new Date())
//             setStopDate(new Date(2099, 1, 1))
//         }
//     }, [permPeriod]);

//     return (
//         <Modal className={success ? successClass : 'form-opinion'} isOpen={isOpen} onClose={() => onClose()}>
//             {fail}
//             <Form action="#" className="form-opinion" id="provide-opinion">
//                 <Header1><Trans>order:PERMISSION_REG</Trans></Header1>
//                 <Label><b><Trans>component:ACCESS_HEADER_VIEW_WHOM</Trans></b></Label>
//                 <Select value={recipient} options={availUsers} onChange={(v) => setRecipient(v)} />
//                 <Label><b><Trans>order:LIC</Trans></b></Label>
//                 <RadioInput value={haveLic} items={[{ value: true, label: t('order:ORDER_LIC_WITH') }, { value: false, label: t('order:ORDER_LIC_WITHOUT') }]} onChange={(v) => setHaveLic(v)} />
//                 {haveLic && <>
//                     <TextInput value={licNum} placeholder={t('order:ORDER_LIC_NO')} onChange={(e) => setLicNum(e.target.value)} />
//                     <TextInput value={licDate} placeholder={t('order:ORDER_LIC_DATE')} onChange={(e) => setLicDate(e.target.value)} />
//                 </>}
//                 <Label><b><Trans>order:PERMISSION_PERIOD</Trans></b></Label>
//                 <Select value={permPeriod} options={[{ value: 1, label: t('order:UNTIL_DATE') }, { value: 2, label: t('order:UNTIL_REVOKE') }]} onChange={(v) => setPermPeriod(v)} />
//                 <DatePicker handleEdit value={startDate} placeholder="" setValue={(v) => setStartDate(v)} />
//                 <DatePicker handleEdit value={stopDate} placeholder="" maxDate={new Date(2100, 1, 1)} setValue={(v) => setStopDate(v)} />
//                 <Label><b><Trans>content:TV</Trans></b></Label>
//                 <MultiSelect value={units} options={availUnits} setValue={(v) => setUnits(v)} />
//                 <Label><b><Trans>Quality</Trans></b></Label>
//                 <MultiSelect value={qualities} options={availQualities} setValue={(v) => setQualities(v)} />
//                 <Label><b><Trans>order:AVAIL_SOURCE</Trans></b></Label>
//                 <RadioInput value={source} items={AVAIL_SOURCES} onChange={(v) => setSource(v)} />
//                 {source === SourcesType.OTHER && <>
//                     <TextInput value={psdetails} placeholder={t('order:PARAMS_PLACEHOLDER')} onChange={(e) => setPSDetails(e.target.value)} />
//                 </>}
//                 <div className="form__submit">
//                     <Button
//                         disabled={isNaN(recipient)}
//                         onClick={() => {
//                             createPermission({
//                                 issuer: auth.account,
//                                 recipient: recipient,
//                                 validity: {},
//                                 details: {
//                                     havelic: haveLic,
//                                     licno: licNum,
//                                     licdate: licDate || null,
//                                     ontest: null,
//                                     sources: [{ stype: source, params: psdetails }],
//                                 },
//                                 units: units.map((u) => ({ fmt: qualities, unit: u, version: null })),
//                                 contracts: []
//                             }).unwrap().then(() => {
//                                 setSuccess(true);
//                                 onClose();
//                             }).catch(e => {
//                                 setFail(JSON.stringify(e));
//                             })
//                         }}
//                     ><Trans>Send permission</Trans></Button>
//                 </div>
//             </Form>
//         </Modal >
//     );
// }

interface CreateButtonProps {
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
}

function CreateButton({ onClick }: CreateButtonProps) {
    const { ref, inView } = useInView({
        threshold: 1
    });

    return (
        // <div ref={ref} className="main__bottom-actions" >
        //     <Button className="btn">
        //         <span className="btn__icon">
        //             <Plus />Документ
        //         </span>
        //     </Button>
        // </div>
        <div ref={ref} className={'content-add__submit' + (inView ? '' : ' _fixed')}>
            <div className="content-add__submit-inner">
                <Button
                    data-test-id="contentSaveButton"
                    type="submit"
                    onClick={(e) => onClick(e)}
                >
                    <span className="btn__icon">
                        <Plus /> <Trans>Document</Trans>
                    </span>
                </Button>
            </div>
        </div>
    );
}

interface DocumentTableRowProps {
    document: RegistryRecord,
    onShowPermissionView: (permId: number) => void
    onUpdate: () => void
}

function DocumentTableRow({ document, onShowPermissionView, onUpdate }: DocumentTableRowProps) {
    return (
        <>
            {document.rectype === RegistryRecordType.CONTRACT ?
                document.contract && <ContractTableRow extId={document.id} contract={document.contract} onShowPermissionView={onShowPermissionView} onUpdate={onUpdate} />
                :
                document.permit && <PermissionTableRow extId={document.id} perm={document.permit} onShowPermissionView={onShowPermissionView} onUpdate={onUpdate} />
            }
        </>
    )
}

interface ContractTableRowProps {
    extId: number,
    contract: Contract,
    onShowPermissionView: (permId: number) => void
    onUpdate: () => void
}

function ContractTableRow({ extId, contract, onShowPermissionView, onUpdate }: ContractTableRowProps) {
    const isAdmin = useIsAdmin();
    const isProvider = useIsProvider();
    const isConsumer = useIsConsumer();
    const isPartnerSource = useIsPartnerSource();

    const [active, setActive] = useState(false);
    const [h, setH] = useState(0);
    const divRef = useRef<HTMLDivElement | null>(null);

    // const [fetchPdf] = useLazyGetAccessPermissionPdfQuery();
    const [showContract, setShowContract] = useState(false);
    const [contractId, setContractId] = useState(NaN);
    const [showComment, setShowComment] = useState(false);
    const [showCreateContractDialog, setShowCreateContractDialog] = useState(false);
    const [setComment] = useSetContractCommentMutation();
    const [getHeader] = useGetMediaHeaderMutation();
    const [deleteContract] = useDeleteContractMutation();

    useEffect(() => {
        if (divRef.current) {
            setH(divRef.current.clientHeight);
        }
    }, [divRef.current, active]);

    return (
        <>
            <CommentModalDialog
                isOpen={showComment}
                onClose={() => setShowComment(false)}
                comment={contract.comment}
                action={(c) => setComment({ id: contract.id, comment: c }).then(() => onUpdate())}
            />
            {showCreateContractDialog && <CreateContractModal contractId={contract.id} isOpen={showCreateContractDialog} onClose={() => setShowCreateContractDialog(false)} />}
            {showContract && <ContractModal isOpen={showContract} contractId={contractId} onClose={() => setShowContract(false)} />}

            <TableRow key={extId} className={active ? '_active' : undefined} onClick={() => setActive((v) => !v)}>
                <TableColumn className="_id">
                    DOC{contract.id}
                    {/* <Link to={`/access/permissions/${perm.id}`}>{perm.id}</Link> */}
                </TableColumn>
                <TableColumn className="_category">
                    TV
                </TableColumn>
                {(isAdmin || isPartnerSource || isConsumer) && <TableColumn className="_producer">
                    {isConsumer ?
                        <strong>
                            <Link to={`/accounts/view/${contract.provider.id}`} className="link-accent">
                                {contract.provider.org.name || contract.provider.name}
                            </Link>
                        </strong>
                        :
                        <Link to={`/accounts/view/${contract.provider.id}`} className="link-accent">
                            {contract.provider.org.name || contract.provider.name}
                        </Link>
                    }
                </TableColumn>}
                {(isAdmin || isPartnerSource || isProvider) && <TableColumn className="_subscriber">
                    <Link to={`/accounts/view/${contract.consumer.id}`} className="link-accent">
                        {contract.consumer.org.name || contract.consumer.name}
                    </Link>
                </TableColumn>}
                <TableColumn className="_doc">
                    <Trans>Contract</Trans>
                </TableColumn>
                <TableColumn className="_doc-n">
                    {contract.number}
                </TableColumn>
                <TableColumn className="_status">{getContractStatus(contract.status)}</TableColumn>
                {(isAdmin || isProvider) && <TableColumn className="_connect"></TableColumn>}
                <TableColumn className="_arrow">
                    <span className="permission__arrow">
                        <Arrow />
                    </span>
                </TableColumn>
                {/* {JSON.stringify(perm)} */}
            </TableRow>
            {active && (
                <div className="table-list__collapsible _active" style={{ display: 'block', height: `${h}px` }}>
                    <div className="table-list__collapsible-body _active">
                        <div ref={divRef} className="registry-list__content">
                            <div className="registry-list__content-item registry-list__content-params">
                                <div className="registry-list__content-params-item">
                                    <div className="registry-list__content-params-item-name"><Trans>Document term</Trans></div>
                                    <div className="registry-list__content-params-item-value">{toMplatValidity(contract.validity)}</div>
                                </div>
                                <div className="registry-list__content-params-item">
                                    <div className="registry-list__content-params-item-name"><Trans>Linked documents</Trans></div>
                                    <div className="registry-list__content-params-item-value _docs">
                                        {contract.permits.map((c, index) => <span key={c}>
                                            <a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                onShowPermissionView(c);
                                            }}><Trans>Permission</Trans>&nbsp;PERM{c}</a>{index < contract.permits.length - 1 ? ', ' : ''}
                                        </span>)}
                                    </div>
                                </div>
                                <div className="registry-list__content-params-item">
                                    <div className="registry-list__content-params-item-name"><Trans>tv:SOURCES</Trans></div>
                                    <div className="registry-list__content-params-item-value">
                                        {/* ZZZ */}
                                        {/*contract.details.sources?.map((ss) => AVAIL_SOURCES.find((s) => s.value === ss.stype)?.label).join(', ') || 'Нет'*/}
                                    </div>
                                </div>
                            </div>
                            <div className="registry-list__content-item _content">
                                <div className="registry-list__content-heading"><Trans>Content</Trans></div>
                                <div className="registry-list__content-channels">
                                    {contract.content?.map((u) => (
                                        <div key={u.id} className="permissions-list__content-channels-item">
                                            {u.covers.at(0) ?
                                                <ImageLoader className="permissions-list__content-channels-item-image" url={u.covers.at(0)} />
                                                :
                                                <div className="permissions-list__content-channels-item-image empty-image" />
                                            }
                                            <div className="permissions-list__content-channels-item-body">
                                                <div className="permissions-list__content-channels-item-name">{u.title}</div>
                                                {/* <div className="permissions-list__content-channels-item-type">{u.category?.name}</div> */}
                                            </div>
                                        </div>
                                        //   {u.fmt.map((q) => q.name).join(', ')}
                                    ))}
                                </div>
                            </div>
                            <div className="registry-list__content-item _comment">
                                <div className="registry-list__content-heading"><Trans>Comment</Trans></div>
                                <div className="order__comment-content">{contract.comment}</div>
                                {contract.comment ?
                                    <span className="link link-accent" onClick={() => setShowComment(true)}><Trans>Edit</Trans><span className="__mobile"> <Trans>comment</Trans></span></span>
                                    :
                                    <span className="link link-accent _comment-add" onClick={() => setShowComment(true)}><Trans>Add</Trans><span className="__mobile"> <Trans>comment</Trans></span></span>
                                }
                            </div>
                            <div className="registry-list__content-item _files">
                                <div className="registry-list__content-heading"><Trans>Files</Trans></div>
                                <ul className="registry-list__content-files">
                                    {contract.files.map((f) => <li>
                                        <a href={BASE_URL.substring(0, BASE_URL.length - 1) + f.url} className="link-file" onClick={(e) => {
                                            e.preventDefault();
                                            getHeader(BASE_URL.substring(0, BASE_URL.length - 1) + f.url).then((d) => {
                                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                                if ((d as any).error?.status === 418) {
                                                    alert(t('content:2FA_ERROR'));
                                                } else {
                                                    window.open(BASE_URL.substring(0, BASE_URL.length - 1) + f.url);
                                                }
                                            }).catch((err) => {
                                                if (err.status === 418) {
                                                    alert(t('content:2FA_ERROR'));
                                                } else {
                                                    alert(extractErrorDetail(err));
                                                }
                                            });
                                        }}>
                                            <FileDoc /> {f.name}
                                        </a>
                                    </li>)}
                                </ul>
                            </div>
                            <div className="registry-list__content-item _edit">
                                <div className="order__permission-cta">
                                    <div className="order__permission-cta-item">
                                        <Button className="_min" type="button" onClick={() => {
                                            setContractId(contract.id);
                                            setShowContract(true);
                                        }}>
                                            <Trans>View</Trans>
                                        </Button>
                                    </div>
                                    {((isAdmin || isProvider) && contract.permits.length === 0) && <div className="order__permission-cta-item">
                                        <Button size="small" onClick={() => setShowCreateContractDialog(true)}>
                                            <Trans>Redact</Trans>
                                        </Button>
                                    </div>}
                                    {((isAdmin || isProvider) && contract.permits.length === 0) && <div className="order__permission-cta-item">
                                        <Button size="small" className="_bd-red" onClick={() => {
                                            const ret = confirm(t('order:ORDER_DELETE_CONFIRM_MESSAGE'));
                                            if (ret) {
                                                deleteContract(contract.id).unwrap().catch((err) => alert(extractErrorDetail(err)));
                                            }
                                        }}>
                                            <Trans>Delete</Trans>
                                        </Button>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

interface PermissionTableRowProps {
    extId: number,
    perm: AccessPermission,
    onShowPermissionView: (permId: number) => void
    onUpdate: () => void
}

function PermissionTableRow({ extId, perm, onShowPermissionView, onUpdate }: PermissionTableRowProps) {
    const isAdmin = useIsAdmin();
    const isProvider = useIsProvider();
    const isConsumer = useIsConsumer();
    const isPartnerSource = useIsPartnerSource();

    const [active, setActive] = useState(false);
    const [h, setH] = useState(0);
    const divRef = useRef<HTMLDivElement | null>(null);

    // const [fetchPdf] = useLazyGetAccessPermissionPdfQuery();
    const [updatePermissionStatus] = useUpdateAccessPermissionStatusMutation();
    const [setComment] = useSetAccessPermissionCommentMutation();
    // const [getHeader] = useGetMediaHeaderMutation();

    const [showComment, setShowComment] = useState(false);
    const [showContract, setShowContract] = useState(false);
    const [contractId, setContractId] = useState(NaN);

    useEffect(() => {
        if (divRef.current) {
            setH(divRef.current.clientHeight);
        }
    }, [divRef.current, active]);

    return (
        <>
            <CommentModalDialog
                isOpen={showComment}
                onClose={() => setShowComment(false)}
                comment={perm.comment}
                action={(c) => setComment({ id: perm.id, comment: c }).then(() => onUpdate())}
            />
            <ContractModal isOpen={showContract} contractId={contractId} onClose={() => setShowContract(false)} />

            <TableRow key={extId} className={active ? '_active' : undefined} onClick={() => setActive((v) => !v)}>
                <TableColumn className="_id">
                    PERM{perm.id}
                    {/* <Link to={`/access/permissions/${perm.id}`}>{perm.id}</Link> */}
                </TableColumn>
                <TableColumn className="_category">
                    TV
                </TableColumn>
                {(isAdmin || isPartnerSource || isConsumer) && <TableColumn className="_producer">
                    {isConsumer ?
                        <strong>
                            <Link to={`/accounts/view/${perm.issuer.id}`} className="link-accent">
                                {perm.issuer.org.name || perm.issuer.name}
                            </Link>
                        </strong>
                        :
                        <Link to={`/accounts/view/${perm.issuer.id}`} className="link-accent">
                            {perm.issuer.org.name || perm.issuer.name}
                        </Link>
                    }
                </TableColumn>}
                {(isAdmin || isPartnerSource || isProvider) && <TableColumn className="_subscriber">
                    <Link to={`/accounts/view/${perm.recipient.id}`} className="link-accent">
                        {perm.recipient.org.name || perm.recipient.name}
                    </Link>
                </TableColumn>}
                <TableColumn className="_doc">
                    <Trans>Permission</Trans>
                </TableColumn>
                <TableColumn className="_doc-n">
                    {perm.id}
                </TableColumn>
                <TableColumn className="_status">{toPermissionStatus(perm.status)}</TableColumn>
                {(isAdmin || isProvider) && <TableColumn className="_connect"></TableColumn>}
                <TableColumn className="_arrow">
                    <span className="permission__arrow">
                        <Arrow />
                    </span>
                </TableColumn>
                {/* {JSON.stringify(perm)} */}
            </TableRow>
            {active && (
                <div className="table-list__collapsible _active" style={{ display: 'block', height: `${h}px` }}>
                    <div className="table-list__collapsible-body _active">
                        <div ref={divRef} className="registry-list__content">
                            <div className="registry-list__content-item registry-list__content-params">
                                <div className="registry-list__content-params-item">
                                    <div className="registry-list__content-params-item-name"><Trans>Document term</Trans></div>
                                    <div className="registry-list__content-params-item-value">{toMplatValidity(perm.validity)}</div>
                                </div>
                                <div className="registry-list__content-params-item">
                                    <div className="registry-list__content-params-item-name"><Trans>Linked documents</Trans></div>
                                    <div className="registry-list__content-params-item-value _docs">
                                        {perm.contracts.map((c, index) => <span key={c.id}>
                                            <a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                setContractId(c.id);
                                                setShowContract(true);
                                            }}><Trans>Contract</Trans>&nbsp;№&nbsp;{c.number}</a>{index < perm.contracts.length - 1 ? ', ' : ''}
                                        </span>)}
                                    </div>
                                </div>
                                <div className="registry-list__content-params-item">
                                    <div className="registry-list__content-params-item-name"><Trans>tv:SOURCES</Trans></div>
                                    <div className="registry-list__content-params-item-value">{perm.details.sources?.map((ss) => AVAIL_SOURCES.find((s) => s.value === ss.stype)?.label).join(', ') || 'Нет'}</div>
                                </div>
                            </div>
                            <div className="registry-list__content-item _content">
                                <div className="registry-list__content-heading"><Trans>content:TV</Trans></div>
                                <div className="registry-list__content-channels">
                                    {perm.units.map((u) => (
                                        <div key={u.unit.id} className="permissions-list__content-channels-item">
                                            {u.unit.covers.at(0) ?
                                                <ImageLoader className="permissions-list__content-channels-item-image" url={u.unit.covers.at(0)} />
                                                :
                                                <div className="permissions-list__content-channels-item-image empty-image" />
                                            }
                                            <div className="permissions-list__content-channels-item-body">
                                                <div className="permissions-list__content-channels-item-name">{u.unit.title}</div>
                                                {/* <div className="permissions-list__content-channels-item-type">{u.unit.category?.name}</div> */}
                                            </div>
                                        </div>
                                        //   {u.fmt.map((q) => q.name).join(', ')}
                                    ))}
                                </div>
                            </div>
                            <div className="registry-list__content-item _comment">
                                <div className="registry-list__content-heading"><Trans>Comment</Trans></div>
                                <div className="order__comment-content">{perm.comment}</div>
                                {perm.comment ?
                                    <span className="link link-accent" onClick={() => setShowComment(true)}><Trans>Edit</Trans><span className="__mobile"> <Trans>comment</Trans></span></span>
                                    :
                                    <span className="link link-accent _comment-add" onClick={() => setShowComment(true)}><Trans>Add</Trans><span className="__mobile"> <Trans>comment</Trans></span></span>
                                }
                            </div>
                            <div className="registry-list__content-item _files" style={{ overflowX: 'hidden', textOverflow: 'ellipsis' }}>
                                {/* <div className="registry-list__content-heading"><Trans>Files</Trans></div>
                                <ul className="registry-list__content-files">
                                    {perm.contracts.flat().map((c) => c.files).flat().map((f) => <li>
                                        <a href={BASE_URL.substring(0, BASE_URL.length - 1) + f.url} className="link-file" onClick={(e) => {
                                            e.preventDefault();
                                            getHeader(BASE_URL.substring(0, BASE_URL.length - 1) + f.url).then((d) => {
                                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                                if ((d as any).error?.status === 418) {
                                                    alert(t('content:2FA_ERROR'));
                                                } else {
                                                    window.open(BASE_URL.substring(0, BASE_URL.length - 1) + f.url);
                                                }
                                            }).catch((err) => {
                                                if (err.status === 418) {
                                                    alert(t('content:2FA_ERROR'));
                                                } else {
                                                    alert(extractErrorDetail(err));
                                                }
                                            });
                                        }}>
                                            <FileDoc /> {f.name}
                                        </a>
                                    </li>)}
                                </ul> */}
                                {/* {isProvider && perm.status === AccessPermissionStatus.ISSUED &&
                                    <div className="registry-list__content-cancel">
                                        <Button className="_bd" onClick={() => {
                                            // eslint-disable-next-line no-restricted-globals
                                            const ret = confirm(t('order:PERMISSION_REVOKE_CONFIRM_MESSAGE'));
                                            if (ret) {
                                                updatePermissionStatus({
                                                    id: perm.id,
                                                    status: AccessPermissionStatus.REVOKED,
                                                    // updated: new Date().toISOString(),
                                                }).unwrap().then(() => {
                                                    // setSuccess(true);
                                                }).catch(e => {
                                                    alert(extractErrorDetail(e));
                                                });
                                            }
                                        }}>
                                            <Trans>order:PERMISSION_REVOKE</Trans>
                                        </Button>
                                    </div>
                                } */}
                            </div>
                            {(isAdmin || isProvider || isConsumer) && <div className="registry-list__content-item _edit">
                                <div className="order__permission-cta">
                                    <div className="order__permission-cta-item">
                                        <Button className="_min" type="button" onClick={() => {
                                            onShowPermissionView(perm.id);
                                        }}>
                                            <Trans>View</Trans>
                                        </Button>
                                    </div>

                                    {isProvider && perm.status === AccessPermissionStatus.ISSUED &&
                                        <div className="order__permission-cta-item">
                                            <Button size="small" className="_bd" onClick={() => {
                                                // eslint-disable-next-line no-restricted-globals
                                                const ret = confirm(t('order:PERMISSION_REVOKE_CONFIRM_MESSAGE'));
                                                if (ret) {
                                                    updatePermissionStatus({
                                                        id: perm.id,
                                                        status: AccessPermissionStatus.REVOKED,
                                                        // updated: new Date().toISOString(),
                                                    }).unwrap().then(() => {
                                                        // setSuccess(true);
                                                    }).catch(e => {
                                                        alert(extractErrorDetail(e));
                                                    });
                                                }
                                            }}>
                                                <Trans>order:PERMISSION_REVOKE</Trans>
                                            </Button>
                                        </div>
                                    }
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

const PAGE_SIZE = 24;

function RegistryContent({ menu }: OuterMenuProps) {
    const auth = useAuth();
    const isAdmin = useIsAdmin();
    const isProvider = useIsProvider();
    const isConsumer = useIsConsumer();
    const isPartnerSource = useIsPartnerSource();

    const [refetctDocuments, { data: docs }] = useLazyGetRegistryQuery();
    const { data: clients } = useGetAccountListQuery({});
    const [fetchXlsData, { data: xlsData }] = useGetXlsMutation();

    const [tStyle, setTStyle] = useState<React.CSSProperties>({ '--width': '1300px' } as unknown as React.CSSProperties);
    const [current, setCurrent] = useState(0);
    const [isFetched, setIsFetched] = useState<boolean>(false);
    const [hasMore, setHasMore] = useState<boolean>(false);
    const [refetch, setRefetch] = useState<boolean>(false);
    const [contractFilter, setContractFilter] = useState<boolean>(false);
    const [permFilter, setPermFilter] = useState<boolean>(false);

    const [ordering, setOrdering] = useState('-id');
    const [showCreateDialog, setShowCreateDialog] = useState(false);
    const [showCreateContractDialog, setShowCreateContractDialog] = useState(false);
    // const [showPermissionModal, setShowPermissionModal] = useState(false);
    const [showPermissionViewModal, setShowPermissionViewModal] = useState(NaN);
    const [search, setSearch] = useState<string>('');
    const [date, setDate] = useState<Date | undefined>();
    const [consumerFilter, setConsumerFilter] = useState<string[]>([]);
    const [providerFilter, setProviderFilter] = useState<string[]>([]);
    const [statusFilter/*, setStatusFilter*/] = useState<number[]>([]);
    // const [mainFilter, setMainFilter] = useState('all');

    const [companyList, setCompanyList] = useState<{
        value: string,
        label: string,
        rtype: number,
    }[]>([]);

    // const statusAvail = useMemo(() => {
    //     return [
    //         { value: 0, label: t('Orders status pending') },
    //         { value: 1, label: t('Orders status granted') },
    //         { value: 2, label: t('Rejected') },
    //     ]
    // }, [t]);

    // const mainFilterItems = useMemo(() => [
    //     { value: 'all', label: t('Orders filter all') },
    //     { value: 'media', label: t('content:MEDIA') },
    //     { value: 'tv', label: t('content:TV') },
    //     { value: 'services', label: t('content:SERVICES') },
    // ], [t]);

    useEffect(() => {
        if (xlsData) {
            saveAs(xlsData, 'permissionlist.xls');
        }
    }, [xlsData]);

    useEffect(() => {
        setIsFetched(true);
        const rectype: number[] = [];
        if (contractFilter !== permFilter) {
            contractFilter && rectype.push(2);
            permFilter && rectype.push(1);
        }
        refetctDocuments({
            offset: current,
            limit: PAGE_SIZE,
            ordering,
            search,
            rectype: rectype.join(','),
            provider_name: providerFilter.join(','),
            consumer_name: consumerFilter.join(','),
            status: statusFilter.join(','),
            date: (date && `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`) || ''
        })
            .then(() => setIsFetched(false))
            .catch(() => setIsFetched(false));
    }, [refetch, current, date, ordering, refetctDocuments, consumerFilter, providerFilter, contractFilter, permFilter, search, statusFilter]);

    useEffect(() => {
        setHasMore(!!docs?.results.next);
    }, [docs?.results]);

    const handleNavigation = useCallback(() => {
        if ((document.body.scrollHeight - window.innerHeight) - window.scrollY < 300 && !isFetched) {
            if (hasMore) {
                setCurrent(docs?.results.data.length || 0);
            }
        }
    }, [docs?.results.data.length, hasMore, isFetched]);

    useEffect(() => {
        window.addEventListener('scroll', handleNavigation);

        return () => {
            window.removeEventListener('scroll', handleNavigation);
        };
    }, [handleNavigation]);

    useEffect(() => {
        refetctDocuments({ offset: current, limit: PAGE_SIZE, ordering, search, status: statusFilter.join(','), crdate: (date && `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`) || '' });
    }, []);

    useEffect(() => {
        if (auth.account && clients?.results.data) {
            setCompanyList(clients.results.data.map((c) => ({ value: c.name, label: c.name, rtype: c.rtype })));
        }
        // const uniqueCompany = new Set<string>();
        // clients?.results.data.every(s => uniqueCompany.add(s.name));
        // const result: {value: string, label: string }[] = [];
        // uniqueCompany.forEach((c) => result.push({value: c, label: c }));
        // setCompanyList(result);
    }, [clients, auth]);

    return (<>
        <CreateDocumentModal isOpen={showCreateDialog} onClose={() => setShowCreateDialog(false)} onCreateDocument={() => setShowCreateContractDialog(true)} />
        {showCreateContractDialog && <CreateContractModal isOpen={showCreateContractDialog} onClose={() => setShowCreateContractDialog(false)} />}
        {/* <PermissionModalModal isOpen={showPermissionModal} onClose={() => setShowPermissionModal(false)} /> */}
        <PermissionViewModal isOpen={!isNaN(showPermissionViewModal)} permId={showPermissionViewModal} onClose={() => setShowPermissionViewModal(NaN)} />

        <div className="main__content-filter">
            {menu}
            {/* <SelectButton sub value={mainFilter} items={mainFilterItems} onChange={(v) => setMainFilter(v)} /> */}
            <div className="main__controls _no-sort">
                <div className="main__controls-filter">
                    <Searcher value={search} onChange={(v) => setSearch(v)} placeholder={t('Search by registry')} />
                    <div className="main__controls-filter-item">
                        <DatePicker value={date} placeholder={t('Date')} setValue={(v) => setDate(v)} />
                    </div>
                    {(isAdmin || isProvider) &&
                        <MultiSelect className="main__controls-filter-item  _wide  _pre-checkbox" placeholder={t('Consumer')}
                            value={consumerFilter} options={companyList.filter((a) => a.rtype === AccountResType.CONSUMER) || []} setValue={(v) => setConsumerFilter(v)} minimized />
                    }
                    {(isAdmin || isConsumer) &&
                        <MultiSelect className="main__controls-filter-item  _wide  _pre-checkbox" placeholder={t('Provider')}
                            value={providerFilter} options={companyList.filter((a) => a.rtype === AccountResType.PROVIDER) || []} setValue={(v) => setProviderFilter(v)} minimized />
                    }
                    {/* <MultiSelect className="main__controls-filter-item  _wide" placeholder={t('Status')}
                        value={statusFilter} options={statusAvail} setValue={(v) => setStatusFilter(v)} minimized /> */}
                    <div className="main__controls-filter-item">
                        <CheckBox value={contractFilter} label={t('Contracts')} onChange={(v) => setContractFilter(v)} />
                    </div>
                    <div className="main__controls-filter-item">
                        <CheckBox value={permFilter} label={t('Permissions')} onChange={(v) => setPermFilter(v)} />
                    </div>
                </div>
                {/* <div className="main__controls-filter-trigger" onClick={() => setFilterVisible(!filterVisible)}>
                    <Filter />
                    {!!filterCount && <span className="main__controls-filter-trigger-counter">{filterCount}</span>}
                </div> */}
                <a href="#xls" className="main__types-file" target="_blank" onClick={(e) => {
                    e.preventDefault();
                    fetchXlsData('/be/api/content/access/permissions/xlsx/');
                }}>
                    <FileDoc />
                    <Trans>Orders xls export</Trans>
                </a>
            </div>
        </div>

        <Table className="_collapsible registry-list" style={tStyle} onResize={(w) => setTStyle({ '--width': `${w}px` } as unknown as React.CSSProperties)}>
            <TableHeader>
                <TableHeaderColumn header="ID" field="id" className="_id" ordering={ordering} setOrdering={setOrdering} />
                <TableHeaderColumn header={t('Category')} className="_category" />
                {(isAdmin || isPartnerSource || isConsumer) && <TableHeaderColumn header={t('Provider')} className="_producer" />}
                {(isAdmin || isPartnerSource || isProvider) && <TableHeaderColumn header={t('Consumer')} className="_subscriber" />}
                <TableHeaderColumn header={t('Document')} className="_doc" />
                <TableHeaderColumn header={t('Document number')} className="_doc-n" />
                <TableHeaderColumn header={t('Status')} field="status" className="_status" ordering={ordering} setOrdering={setOrdering} />
                {(isAdmin || isProvider) && <TableHeaderColumn header={''} className="_connect" />}
                <TableHeaderColumn className="_collapsible-arrow" header={''} />
            </TableHeader>
            <TableBody>
                {docs?.results.data?.map((doc) => (
                    <DocumentTableRow key={doc.id} document={doc} onShowPermissionView={(pid) => setShowPermissionViewModal(pid)} onUpdate={() => setRefetch(!refetch)} />
                ))}
            </TableBody>
        </Table>
        {(isProvider || isAdmin) &&
            <CreateButton onClick={() => setShowCreateDialog(true)} />
        }
    </>)
}

export default RegistryContent;
